import type { HrDataIssues } from './types';

export const buildAnalysisPrompt = (issues: HrDataIssues) => {
  const duplicateCount = issues.duplicates.length;
  const gapCount = issues.gaps.length;
  const missingSeconds = issues.gaps.reduce(
    (sum, gap) => sum + gap.missingTimestamps.length,
    0
  );

  const systemPrompt = `Sei un revisore di qualità dati fisiologici HR/HRV/LF/HF.
Devi analizzare un elenco di problemi già rilevati deterministicamente e produrre una sintesi in italiano.

Definizioni:
- Duplicato: più eventi nello stesso secondo logico (timestamp arrotondato al secondo)
- Gap: uno o più secondi mancanti tra due secondi logici consecutivi con dati

Non inventare problemi non presenti nell'evidence.
Se ci sono duplicati o gap elencati, lo status deve essere "needs_repair".
Se l'evidence è vuota, lo status deve essere "clean".

Rispondi SOLO con JSON valido:
{
  "status": "needs_repair" | "clean",
  "summary": "stringa breve in italiano",
  "findings": ["punto 1", "punto 2"]
}`;

  const userPrompt = `Evidence problemi rilevati (JSON):
${JSON.stringify(
  {
    duplicateCount,
    gapCount,
    missingSeconds,
    duplicates: issues.duplicates.map(item => ({
      secondTimestamp: item.secondTimestamp,
      eventCount: item.events.length,
      sourceTimestamps: item.events.map(event => event.timestamp),
    })),
    gaps: issues.gaps.map(item => ({
      fromTimestamp: item.fromTimestamp,
      toTimestamp: item.toTimestamp,
      missingTimestamps: item.missingTimestamps,
    })),
  },
  null,
  2
)}

Produci summary e findings in italiano.`;

  return [
    { role: 'system', content: systemPrompt },
    { role: 'user', content: userPrompt },
  ] as Array<{ role: string; content: string }>;
};
